import requestAction from '../../utils/requestAction'
import { AssignationInput, AssignationStatus } from '../../models/Assignation';

export const bulkUpsertAssignations = (records: AssignationInput[], initialStatus: AssignationStatus, forceUpdate: boolean) =>
  requestAction('ASSIGNATION_BULK_UPSERT')('assignations/bulk', 'POST', { records, initialStatus, forceUpdate })
